<template>
  <a-tabs v-model:activeKey="activeKey" @change="handleActiveKey">
    <a-tab-pane key="1" tab="价格日历">
      <div class="condition">
        <!-- 搜索 -->
        <div ref="searchRef" class="header-bar">
          <div class="bar-lef">
            <div class="lef-group">
              <div class="group-one">
                <a-date-picker
                    picker="month"
                    placeholder="月份"
                    @change="updateDateChange"
                />
              </div>

              <div class="group-one">
                <a-select
                    v-model:value="searchForm.channelId"
                    :dropdownMatchSelectWidth="false"
                    :filterOption="optionFilter"
                    allowClear="true"
                    max-tag-count="responsive"
                    mode="multiple"
                    placeholder="渠道"
                    @change="handleChange"
                >
                  <a-select-option
                      v-for="item in searchList.ota?.list"
                      :key="item.id"
                      :value="item.id"
                  >{{ item.name }}
                  </a-select-option
                  >
                </a-select>
              </div>
              <div class="group-one">
                <a-select
                    v-model:value="searchForm.rids"
                    :dropdownMatchSelectWidth="false"
                    :filterOption="optionFilter"
                    allowClear="true"
                    max-tag-count="responsive"
                    mode="multiple"
                    placeholder="房型"
                    @change="handleChange"
                >
                  <a-select-option
                      v-for="item in searchList.room?.list"
                      :key="item.id"
                      :value="item.id"
                  >{{ item.name }}
                  </a-select-option
                  >
                </a-select>
              </div>
              <div class="group-one">
                <a-select
                    v-model:value="searchForm.gids"
                    :dropdownMatchSelectWidth="false"
                    :filterOption="optionFilter"
                    allowClear="true"
                    max-tag-count="responsive"
                    mode="multiple"
                    placeholder="分组"
                    @change="handleChange"
                >
                  <a-select-option
                      v-for="item in searchList.group?.list"
                      :key="item.id"
                      :value="item.id"
                  >{{ item.name }}
                  </a-select-option
                  >
                </a-select>
              </div>
              <div class="group-one">
                <a-select
                    v-model:value="searchForm.sids"
                    allowClear="true"
                    max-tag-count="responsive"
                    placeholder="排序"
                    @change="handleChange"
                >
                  <a-select-option value="1">按时间升序</a-select-option>
                  <a-select-option value="2">按时间降序</a-select-option>
                  <a-select-option value="3">按名称升序</a-select-option>
                  <a-select-option value="4">按名称降序</a-select-option>
                </a-select>
              </div>
            </div>
            <div class="lef-one">
              <a-input-search
                  v-model:value="searchForm.name"
                  allowClear="true"
                  placeholder="请输入房间名称"
                  style="width: 200px"
                  @search="onSearch"
              />
            </div>
          </div>
          <div class="bar-rig">
            <div class="rig-one">
              <a-button @click="handleReadShow">
                <template #icon>
                  <reload-outlined/>
                </template>
                读取日历价
              </a-button>
            </div>
          </div>
        </div>
        <!-- 表格 -->
        <a-spin :spinning="tableLoading">
          <div class="condition-table">
            <!-- 房型 房间 -->
            <div class="table-left">
              <div class="left-top">
                <div class="top-cell">房型/房间</div>
              </div>
              <div
                  id="leftBom"
                  :style="{
                  height: contentHeight - 100 + 'px',
                }"
                  class="left-bom"
              >
                <!-- 房型 -->
                <div class="bom_house_type">房型</div>
                <div
                    v-for="(item, index) in dataList.left?.room"
                    :key="index"
                    class="bom-cells"
                >
                  <!-- 房型 -->
                  <div class="cells_house">
                    <div class="house_left">
                      <a-image
                          :preview="false"
                          :src="imgCut(item.image || companyInfo.logo, 's')"
                          height="30px"
                          width="40px"
                      />
                    </div>
                    <div class="house_right">
                      <div :title="item.name" class="right_title">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                  <!-- OTA 房型 -->
                  <div
                      v-for="it in item.child"
                      :key="it.hid"
                      class="cells_room"
                  >
                    <div class="room_name">
                      <div class="name_right">
                        <div :title="it.name" class="right_title">
                          {{ it.name }}
                        </div>
                        <div class="right_info">
                          <div class="info_icon">
                            <a-avatar :size="16" :src="it.logo"/>
                          </div>
                          <div class="info_account">{{ it.ota_com_name }}</div>
                        </div>
                      </div>
                    </div>
                    <!-- OTA -->
                    <span v-show="false">
                      {{ it }}
                    </span>
                  </div>
                  <!-- PMS -->
                  <span v-show="false">
                    {{ item }}
                  </span>
                </div>

                <!-- 房间 -->
                <div class="bom_house_type">房间</div>
                <div
                    v-for="(item, index) in dataList.left?.house"
                    :key="index"
                    class="bom-cells"
                >
                  <!-- 房间 -->
                  <div class="cells_house">
                    <div class="house_left">
                      <a-image
                          :preview="false"
                          :src="imgCut(item.image || companyInfo.logo, 's')"
                          height="30px"
                          width="40px"
                      />
                    </div>
                    <div class="house_right">
                      <div :title="item.name" class="right_title">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                  <!-- OTA 房间 -->
                  <div
                      v-for="it in item.child"
                      :key="it.hid"
                      class="cells_room"
                  >
                    <div class="room_name">
                      <div class="name_right">
                        <div :title="it.name" class="right_title">
                          {{ it.name }}
                        </div>
                        <div class="right_info">
                          <div class="info_icon">
                            <a-avatar :size="16" :src="it.logo"/>
                          </div>
                          <div class="info_account">{{ it.ota_com_name }}</div>
                        </div>
                      </div>
                    </div>
                    <!-- OTA -->
                    <span v-show="false">
                      {{ it }}
                    </span>
                  </div>
                  <!-- PMS -->
                  <span v-show="false">
                    {{ item }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 日期 余量 房态 -->
            <div class="table_right">
              <div class="right_top">
                <div
                    v-for="(item, index) in headList"
                    :key="index"
                    class="top_cell"
                >
                  <div class="cell_date">
                    <div class="date_time">
                      <span
                          v-if="item.date == dates.today"
                          class="time_today"
                      >{{ item.date }}</span
                      >
                      <span v-else>{{ item.date }}</span>
                    </div>
                    <div class="date_week">
                      <span v-if="item.time == dates.toyear" class="week_today"
                      >今天</span
                      >
                      <span v-else-if="item.holidayname" class="week_red">{{
                          item.holidayname
                        }}</span>
                      <span
                          v-else-if="item.week == '六' || item.week == '日'"
                          class="week_red"
                      >{{ item.week }}</span
                      >
                      <span v-else>{{ item.week }}</span>
                    </div>
                    <span v-if="item.holidayname" class="date_holiday">休</span>
                  </div>
                  <div class="cell_more">余{{ item.remain_count }}</div>
                </div>
              </div>
              <div
                  id="rightBom"
                  :style="{ height: contentHeight - 100 + 'px' }"
                  class="right_bom"
                  @scroll="handleScroll"
              >
                <div class="bom_house_type"></div>
                <div
                    v-for="(item, index) in dataList.con?.room"
                    :key="index"
                    class="bom_row"
                >
                  <div
                      v-for="(it, ix) in item"
                      :key="ix"
                      :class="{
                      isSel:
                        houseType == 1 &&
                        selHouse.rid == it.rid &&
                        selHouse.date.includes(it.date),
                      isClose: it.status == 3,
                    }"
                      class="row_cell"
                      @click="handleSelHouse(it, 1)"
                  >
                    <div
                        :class="{ isBan: it.date < dates.toyear }"
                        :style="{
                        'font-weight': it.ota_id ? 'normal' : 'bold',
                      }"
                        class="cell_room"
                    >
                      {{ it.price }}
                    </div>
                  </div>
                </div>
                <!-- 房间 -->
                <div class="bom_house_type"></div>
                <div
                    v-for="(item, index) in dataList.con?.house"
                    :key="index"
                    class="bom_row"
                >
                  <div
                      v-for="(it, ix) in item"
                      :key="ix"
                      :class="{
                      isSel:
                        houseType == 2 &&
                        selHouse.hid == it.hid &&
                        selHouse.date.includes(it.date),
                      isClose: it.status == 3,
                    }"
                      class="row_cell"
                      @click="handleSelHouse(it, 2)"
                  >
                    <div
                        :class="{ isBan: it.date < dates.toyear }"
                        :style="{
                        'font-weight': it.ota_id ? 'normal' : 'bold',
                      }"
                        class="cell_room"
                    >
                      {{ it.price }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
        <!-- 改价 -->
        <AmendPrice
            v-if="priceShow"
            :hid="selHouse.hid"
            :priceDate="priceDate"
            :rid="selHouse.rid"
            :type="houseType"
            @changeDate="priceDateChange"
            @closeAmendPrice="priceShow = false"
            @refreshAmendPrice="init()"
        />

        <!-- 左右箭头 -->
        <div class="table-arrow">
          <div class="arrow-left" @click="handleTableLeftArrow">
            <left-outlined style="color: #0094ff"/>
          </div>
          <div class="arrow-cont">
            <span @click="handleLocationToday">今天</span>
          </div>
          <div class="arrow-right" @click="handleTableRightArrow">
            <right-outlined style="color: #0094ff"/>
          </div>
        </div>
      </div>
    </a-tab-pane>
    <a-tab-pane key="2" tab="批量改价">
      <div class="batch">
        <!-- 选择房间 房型 -->
        <div class="batch-sel">
          <div class="sel-title">房间与房型</div>
          <div class="sel-box">
            <div class="box-tag">
              <div
                  :class="{ isSels: typeKey == 1 ? '#0094ff' : '' }"
                  class="tag-room"
                  @click="typeKey = 1"
              >
                房间
              </div>
              <div
                  :class="{ isSels: typeKey == 2 ? '#0094ff' : '' }"
                  class="tag-room"
                  @click="typeKey = 2"
              >
                房型
              </div>
            </div>
            <div v-show="typeKey == 1" class="box-list">
              <div
                  v-for="item in roomList.list"
                  :key="item.id"
                  :class="{ isBatchsSel: selBatchsRoom.includes(item.id) }"
                  class="list-cell"
                  @click="handleBatchsSelRoom(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <div v-show="typeKey == 2" class="box-list">
              <div
                  v-for="item in houseList.list"
                  :key="item.id"
                  :class="{ isBatchsSel: selBatchsHouse.includes(item.id) }"
                  class="list-cell"
                  @click="handleBatchsSelHouse(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <!-- 选择日期 -->
        <div class="batch-date">
          <div class="date-title">日期</div>
          <div class="date-box">
            <div class="box-tag">
              <div
                  :class="{ isSels: dateKey == 1 ? '#0094ff' : '' }"
                  class="tag-room"
                  @click="handleDateKey(1)"
              >
                连选日期
              </div>
              <div
                  :class="{ isSels: dateKey == 2 ? '#0094ff' : '' }"
                  class="tag-room"
                  @click="handleDateKey(2)"
              >
                点选日期
              </div>
              <div v-if="selDay.length" class="box_nights">
                已选择
                {{ selDay.sort()[0] }}
                ~
                {{ selDay.sort()[selDay.length - 1] }}
                共 {{ selDay.length }} 个间晚
              </div>
            </div>
            <a-spin :spinning="isLoading">
              <div class="date-calendar">
                <!-- 左右箭头 -->
                <div class="arrow-left" @click="handleLeftArrow">
                  <left-outlined style="color: #0094ff; font-size: 24px"/>
                </div>
                <div class="arrow-right" @click="handleRightArrow">
                  <right-outlined style="color: #0094ff; font-size: 24px"/>
                </div>

                <div
                    v-for="(item, index) in calendarList"
                    :key="index"
                    class="calendar-box"
                >
                  <div class="box-year">{{ item.date }}</div>
                  <div class="box-week">
                    <div class="week-cell weekend">周日</div>
                    <div class="week-cell">周一</div>
                    <div class="week-cell">周二</div>
                    <div class="week-cell">周三</div>
                    <div class="week-cell">周四</div>
                    <div class="week-cell">周五</div>
                    <div class="week-cell weekend">周六</div>
                  </div>
                  <div class="box-num">
                    <div
                        v-for="(it, ix) in item.list"
                        :key="ix"
                        :class="{ isSelDay: selDay.includes(it.date) }"
                        :style="{ opacity: it.empty === 'xxx' ? 0 : '' }"
                        class="num-cell"
                        @click="handleSelDay(it)"
                    >
                      <div
                          :class="{ cancelDay: it.date < today }"
                          class="cell-day"
                      >
                        {{ it.day }}
                      </div>
                      <div
                          :style="{
                          color: selDay.includes(it.date) ? '#fff' : '',
                        }"
                          class="cell-holiday"
                      >
                        {{ it.holidayname }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a-spin>

            <div class="date-fast">
              <div class="fast-holiday">
                <div class="holiday-title">快速定位:</div>
                <div class="holiday-list">
                  <div
                      v-for="(item, index) in holidayList"
                      :key="index"
                      class="list-cell"
                      @click="handleSelHoliday(item)"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="fast-week">
                <div class="week-title">星期筛选:</div>
                <div class="week-list">
                  <a-checkbox-group v-model:value="selWeek" style="width: 100%">
                    <a-checkbox
                        v-for="item in 7"
                        :key="item"
                        :disabled="!selWeek.includes(item)"
                        :value="item"
                        @change="checkboxChange"
                    >
                      周{{ "日一二三四五六".charAt(item - 1) }}
                    </a-checkbox>
                  </a-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 价格 -->
        <div class="batch-price">
          <div class="price-title">价格</div>
          <div class="price-box">
            <div class="box-cell">
              <div class="cell-title">一键改价</div>
              <div class="cell-inp">
                <a-input
                    v-model:value="batchForm.oneKeyMoney"
                    allowClear="true"
                    onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                    placeholder="价格"
                    style="width: 200px"
                    @change="oneKeyMoneyChange"
                />
              </div>
            </div>
            <div class="box-cell">
              <div class="cell-title">系统价</div>
              <div class="cell-inp">
                <a-input
                    v-model:value="batchForm.money"
                    allowClear="true"
                    onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                    placeholder="价格"
                    style="width: 200px"
                />
              </div>
            </div>
            <div v-for="item in otaList" :key="item.ota_id" class="box-cell">
              <div class="cell-title f-c-b">{{ item.ota_name }}</div>
              <div class="cell-inp">
                <a-input
                    v-model:value="item.price"
                    allowClear="true"
                    onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                    placeholder="价格"
                    style="width: 200px"
                />
              </div>
            </div>
            <div class="box-btn">
              <a-button type="primary" @click="handleBatchsConfirm"
              >修改价格
              </a-button
              >
            </div>
          </div>
        </div>
      </div>
    </a-tab-pane>
  </a-tabs>

  <!-- 读日历价 -->
  <Reading :params="params" @refresh="refresh"/>
</template>

<script>
import {verifyPrice} from "@/common/validator";
import Reading from "@/components/pms/landlord/Reading/Reading.vue";
import {onMounted, reactive, toRefs, watch} from "vue";
import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import store from "@/store/pms/landlord/index";
import {LeftOutlined, ReloadOutlined, RightOutlined,} from "@ant-design/icons-vue";
import {
  editBathsPrice,
  getDateCalendar,
  getDetailsPrice,
  getHeadList,
  getHolidayDate,
  getHouseCalendar,
  getHouseList,
  getRoomList,
  getRoomPrice,
  getSearchList,
  housePirceEdit,
  houseStatusEdit,
  otaAccountList,
} from "@/api/api";
import {message} from "ant-design-vue";
import useUtils from "@/hooks/useUtils.js";
import AmendPrice from "../../../../components/pms/landlord/AmendPrice/AmendPrice.vue";

dayjs.extend(calendar);

export default {
  components: {
    LeftOutlined,
    RightOutlined,
    ReloadOutlined,
    Reading,
    AmendPrice,
  },
  setup() {
    const {diffDate, imgCut} = useUtils();

    // 父子组件 通讯
    const messages = reactive({
      params: {
        title: "读取渠道日历价",
        sync_ids: "3",
        show: false,
      },

      // 激活渠道盒子
      handleReadShow() {
        messages.params.show = true;
      },
      // 子组件回调
      refresh() {
        houses.init();
      },
    });

    //   搜索
    const searchs = reactive({
      searchList: [],
      searchForm: {
        name: "",
        date: dayjs().subtract(3, "day").format("YYYY-MM-DD"),
        order: [],
        rids: [],
        gids: [],
        channelId: [],
        sids: null,
      },
      optionFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      // 时间
      updateDateChange(_, dateString) {
        searchs.searchForm.date = dateString;
        houses.init();
      },

      //   搜索
      onSearch() {
        houses.init();
      },
      // 查询
      handleChange() {
        houses.init();
      },

      // 搜索列表
      getSearchList() {
        // 获取查询参数列表
        getSearchList().then((res) => {
          searchs.searchList = res.data;
        });
      },
    });

    // 改价
    const prices = reactive({
      priceShow: false,
      selHouse: {
        hid: "",
        rid: "",
        date: [],
        price: "",
        type: 1,
        stime: "",
        etime: "",
      },
      ota_id: undefined,
      cota_id: undefined,
      houseType: "", // 1 房型 2 房间
      // 改价
      priceActiveKey: "1",
      priceSelWeek: [],
      // 周几回调
      PriceCheckboxChange(v) {
        let val = v.target.value;
        let days = prices.selHouse.date;
        days.forEach((item, index) => {
          if (val == dayjs(item).day() + 1) {
            days.splice(index, 1);
          }
        });
      },
      housePriceData: "",
      priceDate: [],
      // 时间回调
      priceDateChange(params) {
        prices.selHouse.date = params;
        // prices.getPriceDetails();
      },
      // 禁用时间
      handleDisabledDate(v) {
        return dayjs(v).format("YYYY-MM-DD") < dayjs().format("YYYY-MM-DD");
      },
      priceSpinning: false,
      // 获取房价详情
      getPriceDetails() {
        prices.priceSpinning = true;
        getDetailsPrice({
          begin: prices.selHouse.date[0],
          end: prices.selHouse.date[prices.selHouse.date.length - 1],
          hid: prices.houseType == 2 ? prices.housePriceInfo.hid : "",
          rid: prices.houseType == 1 ? prices.housePriceInfo.rid : "",
        })
            .then((res) => {
              // let hAry = prices.houseType == 1 ? houses.dataList.con?.room : houses.dataList.con?.house
              // console.log(hAry)
              // let a = hAry.filter(item =>{
              //   console.log(item)
              //   return item.some(it=>prices.selHouse.date.includes(it.date) && (prices.houseType == 1 ? it.rid : it.hid) == (prices.houseType == 1 ? res.data.room.rid : res.dta.house.hid))
              // })
              // console.log(a)
              // let a = hAry.map(item =>{
              //   return item.filter(it =>{
              //     return prices.selHouse.date.includes(it.date) && (prices.houseType == 1 ? it.rid : it.hid) == (prices.houseType == 1 ? res.data.room.rid : res.dta.house.hid)
              //   })
              // })
              // console.log(a)

              if (prices.houseType == 1) {
                prices.housePriceData = {
                  ...res.data.room,
                  price: "",
                  status: "",
                  child: res.data.room?.child.map((item) => {
                    return {...item, price: "", status: ""};
                  }),
                };
              } else {
                prices.housePriceData = {
                  ...res.data.house,
                  price: "",
                  status: "",
                  child: res.data.house?.child.map((item) => {
                    return {...item, price: "", status: ""};
                  }),
                };
              }
            })
            .finally(() => {
              prices.priceSpinning = false;
            });
      },
      // 一键改价
      handleOneKey(v) {
        prices.housePriceData = {
          ...prices.housePriceData,
          price: v.target.value,
          child: prices.housePriceData.child.map((item) => {
            return {
              ...item,
              price: v.target.value,
            };
          }),
        };
      },
      // 确定
      handleConfirm() {
        // 1改价 2锁房开房
        if (prices.priceActiveKey == 1) {
          let params = {
            [prices.houseType == 1 ? "rid" : "hid"]:
                prices.houseType == 1
                    ? prices.housePriceData.rid
                    : prices.housePriceData.hid,
            price: prices.housePriceData.price,
            child: prices.housePriceData.child.map((item) => {
              return {
                ota_house_id: item.ota_house_id,
                price: item.price,
              };
            }),
          };

          housePirceEdit({
            price_list: JSON.stringify(params),
            dates: prices.selHouse.date.join(","),
            type: prices.houseType == 1 ? 2 : 1,
          }).then((res) => {
            message.success(res.msg);
            prices.priceShow = false;
            prices.selHouse.id = "";
            prices.selHouse.date = [];
            prices.selHouse.price = "";
            houses.init();
          });
        } else {
          let params = {
            [prices.houseType == 1 ? "rid" : "hid"]:
                prices.houseType == 1
                    ? prices.housePriceData.rid
                    : prices.housePriceData.hid,
            status: prices.housePriceData.status,
            child: prices.housePriceData.child.map((item) => {
              return {
                ota_house_id: item.ota_house_id,
                status: item.status,
              };
            }),
          };
          houseStatusEdit({
            price_list: JSON.stringify(params),
            dates: prices.selHouse.date.join(","),
            type: prices.houseType == 1 ? 2 : 1,
          }).then((res) => {
            message.success(res.msg);
            prices.priceShow = false;
            prices.selHouse.id = "";
            prices.selHouse.date = [];
            prices.oneKeyStatus = "";
            houses.init();
          });
        }
      },
      housePriceInfo: "",
      //   选中房间
      handleSelHouse(cell, type) {
        console.log(cell);
        if (cell.date < dayjs().format("YYYY-MM-DD")) {
          message.warn("历史日期不可改价");
          return;
        }
        prices.houseType = type;
        prices.housePriceInfo = cell;
        // 房型
        if (type == 1) {
          prices.selHouse.hid = "";
          if (prices.selHouse.rid == cell.rid) {
            if (prices.selHouse.etime) {
              prices.selHouse.date = [];
              prices.selHouse.etime = "";
              prices.selHouse.stime = cell.date;
              prices.selHouse.date.push(cell.date);
            } else {
              prices.selHouse.etime = cell.date;
              prices.selHouse.date = diffDate(
                  prices.selHouse.stime,
                  prices.selHouse.etime
              );
            }
            console.log(prices.selHouse.date);
          } else {
            prices.selHouse.rid = cell.rid;
            prices.selHouse.date = [];
            prices.selHouse.date.push(cell.date);
            prices.selHouse.stime = cell.date;
            prices.selHouse.etime = "";
          }
        } else {
          // 房间
          prices.selHouse.rid = "";
          if (prices.selHouse.hid == cell.hid) {
            if (prices.selHouse.etime) {
              prices.selHouse.date = [];
              prices.selHouse.etime = "";
              prices.selHouse.stime = cell.date;
              prices.selHouse.date.push(cell.date);
            } else {
              prices.selHouse.etime = cell.date;
              prices.selHouse.date = diffDate(
                  prices.selHouse.stime,
                  prices.selHouse.etime
              );
            }
            console.log(prices.selHouse.date);
          } else {
            prices.selHouse.hid = cell.hid;
            prices.selHouse.date = [];
            prices.selHouse.date.push(cell.date);
            prices.selHouse.stime = cell.date;
            prices.selHouse.etime = "";
          }
        }
        prices.selHouse.hid = cell.hid;
      },
      // 开房 锁房
      oneKeyStatus: "",
      // 一键不变
      handleOneKeyStatus(status) {
        prices.oneKeyStatus = status;
        prices.housePriceData = {
          ...prices.housePriceData,
          status,
          child: prices.housePriceData.child.map((item) => {
            return {
              ...item,
              status: status,
            };
          }),
        };
      },
    });

    // 数据表格
    const houses = reactive({
      dataList: "",
      headList: "",
      contentHeight: Number(store.state.ContentHeight) - 82 - 68,
      activeKey: "1",
      tableLoading: false,
      companyInfo: {
        logo: JSON.parse(sessionStorage.getItem("companyInfo") || '{}').logo || '',
      },
      dates: {
        today: dayjs().format("MM-DD"),
        toyear: dayjs().format("YYYY-MM-DD"),
      },
      // rightBom
      handleScroll() {
        document.getElementById("leftBom").scrollTop =
            document.getElementById("rightBom").scrollTop;
      },

      // 初始化
      init() {
        prices.priceActiveKey = "1";
        houses.tableLoading = true;
        // 内容数据
        getRoomPrice({
          begin:
              searchs.searchForm.date ||
              (searchs.searchForm.date = dayjs().format("YYYY-MM-DD")),
          end: dayjs(searchs.searchForm.date)
              .add(1, "month")
              .format("YYYY-MM-DD"),
          rids: searchs.searchForm.rids.join(","),
          name: searchs.searchForm.name,
          group_ids: searchs.searchForm.gids.join(","),
          ota_ids: searchs.searchForm.channelId.join(","),
          sort: searchs.searchForm.sids,
        })
            .then((res) => {
              houses.dataList = res.data;
            })
            .finally(() => {
              houses.tableLoading = false;
            });

        // 头部 时间 星期 假日
        getHeadList({
          begin:
              searchs.searchForm.date ||
              (searchs.searchForm.date = dayjs().format("YYYY-MM-DD")),
          end: dayjs(searchs.searchForm.date)
              .add(1, "month")
              .format("YYYY-MM-DD"),
          rids: searchs.searchForm.rids.join(","),
          name: searchs.searchForm.name,
          group_ids: searchs.searchForm.gids.join(","),
          ota_ids: searchs.searchForm.channelId.join(","),
        }).then((res) => {
          houses.headList = res.data;
        });
      },
    });

    // 批量改价
    const batchs = reactive({
      roomList: "",
      houseList: "",
      calendarList: "",
      holidayList: "",
      typeKey: 1,
      dateKey: 1,
      selDay: [],
      selStime: "",
      selEtime: "",
      selBatchsRoom: [],
      selBatchsHouse: [],
      batchForm: {
        money: "",
        oneKeyMoney: "",
      },
      selWeek: [],

      // 一键改价 配置
      oneKeyMoneyChange(v) {
        batchs.batchForm.money = v.target.value;
        batchs.otaList.forEach((item) => {
          item.price = v.target.value;
        });
      },

      // 选择周几
      checkboxChange(v) {
        let val = v.target.value;
        let days = batchs.selDay;
        days.forEach((item, index) => {
          if (val == dayjs(item).day() + 1) {
            days.splice(index, 1);
          }
        });
      },
      // 计算周几
      diffWeek() {
        let days = batchs.selDay;
        batchs.selWeek = Array.from(
            new Set(days.map((item) => dayjs(item).day() + 1))
        );
      },

      today: dayjs().format("YYYY-MM-DD"),
      isLoading: false,
      calendarDate: dayjs().format("YYYY-MM-DD"),
      // activeKey
      handleActiveKey(key) {
        prices.priceShow = false;
        prices.selHouse.date = [];
        if (key == 2) {
          batchs.getCalendarList();
          batchs.getHolidayList();
          batchs.getHouseList();
          batchs.getAccountList();
        } else {
          houses.init();
          searchs.getSearchList();
        }
      },
      otaList: [],
      // 获取账号所有渠道
      getAccountList() {
        otaAccountList().then((res) => {
          batchs.otaList = res.data;
        });
      },

      // 左右箭头 批量改价 日历
      handleLeftArrow() {
        batchs.calendarDate = dayjs(batchs.calendarDate)
            .subtract(4, "month")
            .format("YYYY-MM-DD");
        batchs.getCalendarList();
      },
      handleRightArrow() {
        batchs.calendarDate = dayjs(batchs.calendarDate)
            .add(4, "month")
            .format("YYYY-MM-DD");
        batchs.getCalendarList();
      },

      // 左右箭头 鸡仔表格数据
      handleTableLeftArrow() {
        searchs.searchForm.date = dayjs(searchs.searchForm.date)
            .subtract(1, "month")
            .format("YYYY-MM-DD");

        houses.init();
      },
      handleTableRightArrow() {
        searchs.searchForm.date = dayjs(searchs.searchForm.date)
            .add(1, "month")
            .format("YYYY-MM-DD");
        houses.init();
      },
      // 定位到今天
      handleLocationToday() {
        searchs.searchForm.date = dayjs().format("YYYY-MM-DD");
        houses.init();
      },

      // 修改价格
      handleBatchsConfirm() {
        console.log(batchs.otaList);
        let priceList = batchs.otaList.map((item) => {
          return {
            ota_id: item.ota_id,
            price: item.price,
          };
        });
        priceList.push({
          price: batchs.batchForm.money,
          ota_id: "1",
        });
        if (batchs.typeKey == 1) {
          editBathsPrice({
            ids: batchs.selBatchsRoom.join(","),
            date: batchs.selDay.join(","),
            ota_list: priceList,
            type: "1",
          }).then((res) => {
            message.success(res.msg);
            houses.init();
            batchs.selBatchsHouse = [];
            batchs.selBatchsRoom = [];
            batchs.selDay = [];
            batchs.selStime = "";
            batchs.selEtime = "";
            batchs.batchForm.money = "";
          });
        } else {
          editBathsPrice({
            ids: batchs.selBatchsHouse.join(","),
            date: batchs.selDay.join(","),
            ota_list: priceList,
            type: "2",
          }).then((res) => {
            message.success(res.msg);
            houses.init();
            batchs.selBatchsHouse = [];
            batchs.selBatchsRoom = [];
            batchs.selDay = [];
            batchs.selStime = "";
            batchs.selEtime = "";
            batchs.batchForm.money = "";
          });
        }
        // if (
        //   batchs.selBatchsRoom.length <= 0 &&
        //   batchs.selBatchsHouse.length <= 0
        // ) {
        //   message.error("请选择房型或房间");
        //   return;
        // }
        // if (batchs.selBatchsRoom.length) {

        // }
        // if (batchs.selBatchsHouse.length) {

        // }
      },

      // 选中房间
      handleBatchsSelRoom(params) {
        console.log(params);
        if (batchs.selBatchsRoom.includes(params.id)) {
          batchs.selBatchsRoom.splice(
              batchs.selBatchsRoom.indexOf(params.id),
              1
          );
        } else {
          batchs.selBatchsRoom.push(params.id);
        }
      },
      // 选中房型
      handleBatchsSelHouse(params) {
        console.log(params);
        if (batchs.selBatchsHouse.includes(params.id)) {
          batchs.selBatchsHouse.splice(
              batchs.selBatchsHouse.indexOf(params.id),
              1
          );
        } else {
          batchs.selBatchsHouse.push(params.id);
        }
      },

      // dateKey
      handleDateKey(num) {
        batchs.dateKey = num;
        batchs.selDay = [];
      },

      // 选中日期
      handleSelDay(it) {
        if (it.empty == "xxx") return;
        if (it.date < dayjs().format("YYYY-MM-DD")) {
          return;
        }
        if (batchs.dateKey == 1) {
          if (batchs.selStime) {
            if (batchs.selStime && batchs.selEtime) {
              batchs.selDay = [];
              batchs.selEtime = "";
              batchs.selDay.push(it.date);
              batchs.selStime = it.date;
            } else {
              batchs.selEtime = it.date;
              batchs.selDay = batchs.getDiffDate(
                  batchs.selStime,
                  batchs.selEtime
              );
            }
          } else {
            batchs.selDay = [];
            batchs.selDay.push(it.date);
            batchs.selStime = it.date;
          }
        } else {
          if (batchs.selDay.length && batchs.selDay.includes(it.date)) {
            batchs.selDay.splice(batchs.selDay.indexOf(it.date), 1);
          } else {
            batchs.selDay.push(it.date);
          }
        }
        batchs.diffWeek();
      },
      // 快速定位
      handleSelHoliday(it) {
        batchs.calendarDate = it.start_time;
        batchs.getCalendarList();
        batchs.selDay = [];
        batchs.dateKey = 2;
        batchs.selDay = batchs.getDiffDate(it.start_time, it.end_time);
      },

      // 获取日期之间的 所有日期
      getDiffDate(stime, etime) {
        var diffdate = new Array();
        if (etime < stime) [stime, etime] = [etime, stime];
        while (stime <= etime) {
          diffdate.push(stime);
          let stime_ts = new Date(stime).getTime();
          let next_date = stime_ts + 24 * 60 * 60 * 1000;
          stime = dayjs(next_date).format("YYYY-MM-DD");
        }
        return diffdate;
      },

      //   读取房间 房型列表
      getHouseList() {
        getHouseList({
          start: 0,
          limit: 999,
        }).then((res) => {
          batchs.roomList = res.data;
        });
        getRoomList({
          start: 0,
          limit: 999,
        }).then((res) => {
          batchs.houseList = res.data;
        });
      },

      // 获取日历表
      getCalendarList() {
        batchs.isLoading = true;
        getDateCalendar({
          date: batchs.calendarDate,
        })
            .then((res) => {
              res.data.forEach((item) => {
                for (let i = item.list[0].week; i > 0; i--) {
                  item.list.unshift({
                    empty: "xxx",
                  });
                }
              });
              batchs.calendarList = res.data;
            })
            .finally(() => {
              batchs.isLoading = false;
            });
      },
      // 获取节假日
      getHolidayList() {
        getHolidayDate().then((res) => {
          batchs.holidayList = res.data;
        });
      },

      // 读取日历
      getCalendar() {
        getHouseCalendar({
          hid: "",
          date: dayjs().format("YYYY-MM"),
        }).then((res) => {
          console.log(res);
        });
      },
    });

    onMounted(() => {
      houses.init();
      searchs.getSearchList();
    });

    watch(
        () => prices.selHouse.etime,
        (newDate) => {
          // 时间长度

          if (newDate) {
            prices.priceShow = true;
            console.log(prices.selHouse);
            prices.priceDate = [
              dayjs(prices.selHouse.date[0]),
              dayjs(prices.selHouse.date[prices.selHouse.date.length - 1]),
            ];
            let days = prices.selHouse.date;
            prices.priceSelWeek = Array.from(
                new Set(days.map((item) => dayjs(item).day() + 1))
            );

            // prices.getPriceDetails();
          } else {
            prices.priceShow = false;
          }
        }
    );

    return {
      imgCut,
      verifyPrice,
      ...toRefs(messages),
      ...toRefs(batchs),
      ...toRefs(prices),
      ...toRefs(searchs),
      ...toRefs(houses),
    };
  },
};
</script>
<style lang="scss" scoped>
// 锁房
.isClose {
  cursor: not-allowed;
  // background-color: #cccccc99 !important;
  background: url(../../../../assets/image/pms_lock.jpg);
  background-size: 60px 50px;
}

.condition {
  position: relative;

  .table-arrow {
    margin-left: 50%;
    transform: translateX(-50%);
    position: absolute;
    height: 46px;
    bottom: 30px;
    z-index: 999;
    display: flex;

    .arrow-left {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 5px;
      box-shadow: 0 1px 8px 0 #ccc;
      cursor: pointer;
    }

    .arrow-cont {
      background-color: #fff;
      border-radius: 46px;
      display: flex;
      box-shadow: 0 1px 8px 0 #ccc;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        height: 30px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #0094ff;
        padding: 0 10px;
        border-radius: 30px;
        color: #fff;
      }
    }

    .arrow-right {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 5px;
      box-shadow: 0 1px 8px 0 #ccc;
      cursor: pointer;
    }
  }

  .condition-search {
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;

    .search_left {
    }

    .search_right {
    }
  }

  .condition-table {
    display: flex;
    border: 1px solid #b4cdff;

    .table-left {
      border-right: 1px solid #b4cdff;

      .left-top {
        width: 200px;

        .top-cell {
          height: 70px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #b4cdff;
          font-size: 20px;
          font-weight: 400;
        }
      }

      .left-bom {
        width: 200px;
        overflow-y: auto;
        overflow: hidden;

        .bom_house_type {
          height: 30px;
          display: flex;
          align-items: center;
          padding-left: 10px;
          border-bottom: 1px solid #b4cdff;
          background-color: #e9f2fd;
        }

        .bom-cells {
          // border-bottom: 2px solid red !important;

          // height: 60px;
          // display: flex;
          // align-items: center;
          // border-bottom: 1px solid #b4cdff;
          // padding: 0 5px;
          // .bom-text {
          //   white-space: nowrap;
          //   overflow: hidden;
          //   text-overflow: ellipsis;
          // }
          .cells_house {
            display: flex;
            align-items: center;
            height: 50px;
            border-bottom: 1px solid #b4cdff;
            padding: 0 5px;
            font-size: 12px;
            font-weight: bold;
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // background-color: #e9f2fd;
            // line-height: 70px;
            .house_left {
              margin-right: 5px;
              border-radius: 4px;
              overflow: hidden;
            }

            .house_right {
              .right_title {
                line-height: 1;
                width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .right_info {
                display: flex;
                align-items: center;

                .info_icon {
                  margin-right: 5px;
                }

                .info_account {
                }
              }
            }
          }

          .cells_room {
            // padding-left: 20px;
            color: #999 !important;

            .room_name {
              height: 50px;
              padding: 0 5px;
              border-bottom: 1px solid #b4cdff;
              display: flex;
              align-items: center;

              .name_left {
                margin-right: 5px;
                border-radius: 4px;
                overflow: hidden;
              }

              .name_right {
                .right_title {
                  line-height: 1;
                  // width: 120px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  font-size: 12px;
                }

                .right_info {
                  display: flex;
                  align-items: center;

                  .info_icon {
                    margin-right: 5px;
                  }

                  .info_account {
                  }
                }
              }
            }

            .room_channel {
              height: 70px;
              padding: 0 5px;
              border-bottom: 1px solid #b4cdff;
              display: flex;
              align-items: center;

              .channel_left {
                margin-right: 5px;
                border-radius: 4px;
                overflow: hidden;
              }

              .channel_right {
                .right_title {
                  width: 120px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }

                .right_info {
                  display: flex;
                  align-items: center;

                  .info_icon {
                    margin-right: 5px;
                  }

                  .info_account {
                    color: #ccc;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .table-right {
      overflow-x: scroll;
      // width: calc(100% - 120px);

      .right-top {
        height: 70px;
        border-bottom: 1px solid #b4cdff;
        display: inline-flex;
        flex-wrap: nowrap;

        .cells {
          border-right: 1px solid #b4cdff;
          width: 60px;

          .top-cell {
            border-bottom: 1px solid #b4cdff;
            height: 50px;

            .cell-date {
              display: flex;
              flex-direction: column;
              align-items: center;
              position: relative;

              .date-time {
              }

              .date-week {
              }

              .date-holiday {
                height: 16px;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                margin: 0;
                padding: 0;
                font-size: 8px !important;
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #fff;
                text-align: center;
                margin: 3px;

                .holiday-name {
                  background-color: #3eeb86;
                  width: 16px;
                  border-radius: 2px;
                }

                .holiday-x {
                  background-color: #ff5147;
                  width: 16px;
                  border-radius: 2px;
                }
              }
            }
          }

          .bom-cell {
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;

            .cell-margin {
            }
          }
        }
      }

      .right-bom {
        overflow-y: scroll;

        // overflow-x: hidden;
        display: inline-flex;
        flex-wrap: wrap;

        .bom-col {
          display: flex;

          .col-row {
            border-bottom: 1px solid #b4cdff;
            border-right: 1px solid #b4cdff;
            width: 60px;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    // 内容
    .table_right {
      overflow-x: scroll;
      // position: relative;
      .right_top {
        display: inline-flex;
        height: 68px;
        border-bottom: 1px solid #b4cdff;

        .top_cell {
          width: 60px;
          text-align: center;
          font-size: 12px !important;

          .cell_date {
            position: relative;

            .date_holiday {
              position: absolute;
              top: 2px;
              right: 2px;
              background-color: #ff5147;
              color: #ffffff;
              line-height: 1.3;
              // padding: 0 2px;
              border-radius: 2px;
            }

            height: 45px;
            color: #999;

            .date_time {
              .time_today {
                color: #0094ff !important;
              }
            }

            .date_week {
              .week_today {
                color: #0094ff;
                background-color: #e9f2fd;
                padding: 0 4px;
                border-radius: 10px;
              }

              .week_red {
                color: #dd0054 !important;
              }
            }
          }

          .cell_more {
            height: 25px;
            border-top: 1px solid #b4cdff;
            border-right: 1px solid #b4cdff;
          }
        }
      }

      .right_bom {
        overflow-y: auto;
        display: inline-block;
        flex-wrap: wrap;
        font-size: 12px !important;
        // position: absolute;
        // left: 70px;
        // // top: 0;
        // right: -17px;
        // // bottom: 0;
        .bom_house_type {
          height: 30px;
          border-bottom: 1px solid #b4cdff;
          background-color: #e9f2fd;
        }

        .bom_row {
          display: flex;

          .isSel {
            // background-color: #0094ff !important;
            // color: #fff !important;
            border: 2px solid #0094ff !important;
            border-radius: 4px;
            color: #0094ff;
            box-sizing: border-box !important;
          }

          .row_cell {
            // box-sizing: border-box !important;
            width: 60px;
            height: 50px;

            .cell_house {
              width: 100%;
              height: 100%;
              // background-color: #e9f2fd;
              // width: 60px;
              // height: 50px;
              border-right: 1px solid #b4cdff;
              border-bottom: 1px solid #b4cdff;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .cell_room {
              width: 100%;
              height: 100%;
              border-right: 1px solid #b4cdff;
              border-bottom: 1px solid #b4cdff;
              display: flex;
              justify-content: center;
              align-items: center;
              // width: 60px;
              // height: 50px;
            }

            .isBan {
              cursor: not-allowed !important;
              // background-color: #f3f3f3 !important;
              box-sizing: border-box;
              background: url(../../../../assets/image/pms_disable.jpg);
              background-size: 60px 50px;
            }
          }
        }
      }
    }
  }
}

// 批量改价
.batch {
  background-color: #fff;
  padding: 10px;

  .batch-sel {
    margin-bottom: 20px;

    .sel-title {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .sel-box {
      .box-tag {
        display: flex;

        .tag-room {
          margin-left: 15px;
          padding: 5px 20px;
          border-radius: 5px 5px 0 0;
          border-bottom: none;
          background-color: #f0f0f0;
        }

        .isSels {
          background-color: #0094ff;
          color: #fff;
        }
      }

      .box-list {
        border: 1px solid #f3f3f3;
        border-radius: 4px;
        display: flex;
        min-height: 100px;
        padding: 5px;
        flex-wrap: wrap;

        .isBatchsSel {
          background-color: #0094ff;
          color: #fff;
        }

        .list-cell {
          border: 1px solid #f3f3f3;
          padding: 0 5px;
          height: 30px;
          border-radius: 4px;
          margin: 4px;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .batch-date {
    margin-bottom: 20px;

    .date-title {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .date-box {
      .box-tag {
        display: flex;
        align-items: center;

        .box_nights {
          margin-left: 15px;
          color: #666666;
        }

        .tag-room {
          margin-left: 15px;
          padding: 5px 20px;
          border-radius: 5px 5px 0 0;
          border-bottom: none;
          background-color: #f0f0f0;
        }

        .isSels {
          background-color: #0094ff;
          color: #fff;
        }
      }

      .date-calendar {
        position: relative;
        border: 1px solid #f3f3f3;
        border-radius: 5px;
        padding: 5px;
        display: flex;
        margin-bottom: 10px;
        overflow-y: auto;
        justify-content: center;
        // .calendar-arrow {
        //   z-index: 99;
        //   position: absolute;
        //   left: 0;
        //   right: 0;
        //   top: 50%;
        //   margin: 0 20px;
        //   display: flex;
        //   justify-content: space-between;
        //   align-items: center;

        .arrow-left {
          z-index: 99;
          position: absolute;
          left: 0;
          top: 50%;

          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background-color: #f7f7f711;
          border-radius: 40px;
          box-shadow: 0 1px 8px 0 #ccc;

          &:hover {
            background-color: #eeeeee;
          }
        }

        .arrow-right {
          z-index: 99;
          position: absolute;
          right: 0;
          top: 50%;

          cursor: pointer;
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f7f7f711;
          border-radius: 40px;
          box-shadow: 0 1px 8px 0 #ccc;

          &:hover {
            background-color: #eeeeee;
          }
        }

        // }
        .calendar-box {
          margin: 0 5px;
          // border: 1px solid #333;
          text-align: center;
          padding: 10px;
          width: 390px;
          background-color: #f9f9f9;

          .box-year {
            font-weight: bold;
            margin-bottom: 10px;
          }

          .box-week {
            display: flex;

            .week-cell {
              width: 58px;
              padding: 3px 5px;
            }

            .weekend {
              color: #dd0054;
            }
          }

          .box-num {
            display: flex;
            flex-wrap: wrap;

            .num-cell {
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 50px;
              height: 50px;
              background-color: #f3f3f3;
              padding: 3px 5px;
              margin: 1px;

              .cell-day {
              }

              .cell-holiday {
                font-size: 10px !important;
                color: #ff5147;
              }
            }

            .isSelDay {
              background-color: #0094ff !important;
              color: #fff !important;
            }
          }
        }
      }

      .date-fast {
        .fast-holiday {
          display: flex;

          .holiday-title {
            color: #ccc;
          }

          .holiday-list {
            display: flex;
            color: #0094ff;

            .list-cell {
              padding: 0 10px;
            }
          }
        }

        .fast-week {
          display: flex;

          .week-title {
            color: #ccc;
          }

          .week-list {
            // display: flex;

            .list-cell {
              padding: 0 10px;
            }
          }
        }
      }
    }
  }

  .batch-price {
    .price-title {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .price-box {
      padding: 5px;
      border: 1px solid #f3f3f3;
      border-radius: 4px;

      .box-cell {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        // width: 20%;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .cell-title {
          width: 10%;
        }

        .cell-inp {
          //  flex: 1;
          margin-left: 10px;
        }
      }

      .box-btn {
        // margin-left: 150px;
      }
    }
  }
}

.cancelDay {
  color: #cccccc !important;
  cursor: not-allowed;
}
</style>